var _linearGradient, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-icon",
    x1: -2.254,
    x2: 35.739,
    y1: 68.986,
    y2: 30.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c5ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M81.939 44.002l-13.548-7.825-13.87 13.87L68.39 63.916l13.595-7.851c2.12-1.288 3.385-3.538 3.385-6.018s-1.266-4.73-3.431-6.045z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-icon)",
    d: "M54.521 50.047L16.742 11.996a7.13 7.13 0 00-2.112 5.068v65.85c0 1.971.798 3.754 2.112 5.069z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00f076",
    d: "M54.521 50.047l13.87-13.87.022-.022-18.584-10.7-24.498-14.398c-2.206-1.361-4.881-1.408-7.134-.141-.516.328-.986.657-1.455 1.079z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f63448",
    d: "M16.742 87.982c.469.422.939.751 1.455 1.079 1.126.61 2.3.939 3.473.939 1.267 0 2.487-.375 3.614-1.032l24.544-14.329 18.584-10.7-.022-.022-13.869-13.87z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.4d3bb36b.svg";
export { ForwardRef as ReactComponent };